const CHUNK_STATS = ['chunkBitrate', 'chunkSize'];
const EVENT_STATS = ['PLAY', 'PAUSE', 'SEEKING', 'WAITING'];

const BUFFER_STATS = ['currentTime', 'bufferTimeRemaining', 'bufferPeriod'];

const MEDIA_STATS = [
  'droppedVideoFrames',
  'totalVideoFrames',
  'bandwidth',
  'codecs',
  'mediaResolution',
  'mediaCode',
  'choosenResolution',
  'user',
  'currentDate',
  'deviceConnection',
];

const AUDIO_STATS = ['bandwidth', 'codecs', 'mediaCode', 'user', 'currentDate', 'deviceConnection'];

const GENERAL_STATS = [
  'viewId',
  'viewport',
  'projectVersion',
  'experimentName',
  'measuredBandwidth',
  'volume',
  'duration',
];

export { CHUNK_STATS, EVENT_STATS, MEDIA_STATS, AUDIO_STATS, GENERAL_STATS, BUFFER_STATS };
